import Content from 'components/Content';
import Icons from 'components/icons';
import { FC, JSX } from 'react';

type HeaderProps = {
  leftButton: JSX.Element;
};

const Header: FC<HeaderProps> = ({ leftButton }) => (
  <Content noMargin className="bg-white">
    <div className="flex justify-between h-20 items-center">
      {leftButton}
      <Icons.Logo className="h-4 w-[128px] text-blue" />
    </div>
  </Content>
);

export default Header;
